var map = {
	"./c11-wifi.png": 1646,
	"./c12-wifi.png": 1647,
	"./c12e-wifi.png": 1648,
	"./c13-wifi.png": 1649,
	"./c13c-wifi.png": 1650,
	"./c15-wifi.png": 1651,
	"./c16-wifi.png": 1652,
	"./c20-wifi.png": 1653,
	"./c21-wifi.png": 1654,
	"./c31-wifi.png": 1655,
	"./c31pro-wifi.png": 1656,
	"./c50-wifi.png": 1657,
	"./c52-wifi.png": 1658,
	"./c71-wifi.png": 1659,
	"./c80-wifi.png": 1660,
	"./cmcc-v1-wifi.png": 1661,
	"./cmcc-v2-wifi.png": 1662,
	"./d1-wifi.png": 1663,
	"./hdc-51-wifi.png": 1664,
	"./hdc-55-wifi.png": 1665,
	"./hdc-63-wifi.png": 1666,
	"./icon-wifi.png": 1570,
	"./other-wifi.png": 1667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1645;